import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { SystemService } from '../../../../services/system.service';
import { Observable, Subscription, Subject, of, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';
import {  MatDialog } from '@angular/material/dialog';
import { StockFillerDataPopupComponent } from './stock-filler-data-popup/stock-filler-data-popup.component';
import { UntypedFormControl } from '@angular/forms';
import { CommonPopup } from 'src/app/admin-dashboard/common-popup/common-popup';
import { ConfigService } from 'src/app/shared/config';
@Component({
  selector: 'app-stock-filler',
  templateUrl: './stock-filler.component.html',
  styleUrls: ['./stock-filler.component.css']
})
export class StockFillerComponent implements OnInit, OnDestroy {
  combObs$ = new Observable()
  rowActionButtons: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[];
  onShowUnit: EventEmitter<ActionButtonEvent>;
  onShowUnitSubscription: Subscription;
  siteId;
  loadingResult : Subject<boolean>;
  systemId;
  emailList = new UntypedFormControl();
  adminEmailList;
  columnSettings: ColumnSetting[] = [
    {
      columnId: 'refrence',
      name: 'Reference'
    },
    {
      columnId: 'status',
      name: 'Status'
    },
    {
      columnId: 'createdOn',
      name: 'Created on'
    },
    {
      columnId: 'updatedOn',
      name: 'Updated on'
    }]

  constructor(private systemService: SystemService, private config: ConfigService,
    private route: ActivatedRoute, private dialog: MatDialog) {


    this.route.params.subscribe(params => {
      this.siteId = params['siteId'];
      this.systemId = params['systemId'];
      this.combObs$ = this.systemService.getStockFillings(params['siteId'], params['systemId']).pipe(map(doc => {
        return doc.map(obj => {
          return {
            siteId: this.siteId,
            systemId: this.systemId,
            ...obj.payload.doc.data() as object,
            stockFillerId: obj.payload.doc.id,
            status: obj.payload.doc.data()['status'] == 0 ? 'Pending' : obj.payload.doc.data()['status'] == 1 ? 'Done' : obj.payload.doc.data()['status'] == 2 ? 'Canceled' : ' Some Issue',
            createdOn: moment(obj.payload.doc.data()['createdOn']).format('MMMM Do YYYY, h:mm:ss a'),
            updatedOn: moment(obj.payload.doc.data()['updatedOn']).fromNow()
          }
        })
      }))

      this.systemService.getSystemEmailList$(this.siteId, this.systemId).subscribe(data => {
        console.log(data.payload.data())
        if (data.payload.data()['emailsForStockFiller'])
          this.emailList = new UntypedFormControl(data.payload.data()['emailsForStockFiller']);
      })

      // combineLatest(of(this.emailList)
      // The admin list came from the retired legacy site users; v2 has no
      // admin flag on memberships, so no one is suggested.
      this.adminEmailList = of([])

    })



    this.onShowUnit = new EventEmitter<ActionButtonEvent>();

    this.rowActionButtons = [
      { icon: 'info_outline', tooltip: 'Show unit', eventEmitter: this.onShowUnit }
    ]

    this.onShowUnitSubscription = this.onShowUnit.subscribe(event => {
      // alert('Not implemented');
      let data = event.eventData
      if (data) {
        this.dialog.open(StockFillerDataPopupComponent, {
          disableClose: true,
          width: '800px',
          data: data
        });
      }
    });
  }

  ngOnInit() {

  }

  async createFiller() {

    let createStockFillerResult = await this.systemService.createStockFiller(this.siteId, this.systemId) as boolean
    this.loadingResult.next(createStockFillerResult)
  }


  updateEmailListForStockFiller() {
    this.systemService.updateEmailListForStockFiller(this.siteId, this.systemId, this.emailList.value)
    console.log(this.emailList.value)
  }

  async openPopup() {
    try {
      let obj = await this.systemService.getSystemTask(this.systemId, 'autoFillerNotification');
      console.log(obj)
      const dialogRef = this.dialog.open(CommonPopup, {
        disableClose: true,
        width: '500px',
        data: {
          siteId: this.siteId,
          text: '',
          formData: {
            title: `Update`,
            inputFeilds: [
              {
                labelName: "Name",
                name: "name",
                required: true,
                type: "text",
                specialText: "",
                value: obj['name'],
              },
              {
                labelName: "Perform At",
                name: "setHour",
                required: true,
                type: null,
                specialText: "",
                value: obj['setHour'],
                selectOptions: this.setHourObj()
              },
              {
                labelName: "Status",
                name: "status",
                required: true,
                disabled: true,
                type: "text",
                value: obj['status'] ? obj['status'] : 'Scheduled',
                specialText: ""
              }
            ],
            buttons: [
              {
                name: "Update",
                type: "submit",
                color: "primary",
                validate: true
              }
            ]
          }
        }
      });

      dialogRef.afterClosed().subscribe(async result => {

        if (result) {
          let object = result.value;
          result.value.worker =  "autoFillerNotification";
          // let performAt = new Date();
          // performAt.setHours(object.setHour);
          // performAt.setMinutes(0)
  
          let interfaceObject = {
              options: {
                  companyId: this.config.getCompanyId(),
                  siteId: this.siteId,
                  systemId: this.systemId
              },
              performAt: moment().hour(Number(object.setHour)).minute(0).unix(),
              setHour: object.setHour,
              status: "scheduled",
              systemId: this.systemId,
              worker: object.worker,
              name: object.name
          }
          this.systemService.createTask(interfaceObject,obj['id'])
          // setHour: result.value.setHour,


        }
      });
    } catch (error) {
      console.log(error)
    }
  }

  setHourObj(){
    let arr = []
    
    for(let i = 0; i < 24;i++)
    {
        arr.push({
          label: i+":00",
          value: i
        })
    }
    return arr
  }

  ngOnDestroy(): void {
    this.onShowUnitSubscription.unsubscribe();
    // this.onExportSubscription.unsubscribe();
  }

}
